import React from 'react';
import pencilIcon from './assets/pencil-design.svg';
import magicIcon from './assets/magic-wand 1.svg';
import { useHistory, useParams } from 'react-router';
function PackageOption() {
  const fisheryId = useParams()['fishery_id'];

  const history = useHistory();
  return (
    <div className='booking-container'>
      <div className='center package-option-container'>
        <div
          className='font-montserrat pack-heading txt-center sb-blue-700 mg-bottom-30'
          style={{ maxWidth: 1130 }}
        >
          THERE ARE TWO WAYS TO MAKE A BOOKING AT EXOTIC FISHING THAILAND.
          PLEASE SELECT YOUR PREFERRED METHOD BELOW:
        </div>
        <div className='build-package-container '>
          <div
            className='footer-box build-package-options font-montserrat fs-28 sb-blue-700 cp'
            onClick={() => {
              history.push(`/booking/view_packages/${fisheryId}`);
            }}
          >
            <img src={magicIcon} width={150} height={150} alt='Build Icon' />
            <span>CHOOSE FROM POPULAR PRE-SET PACKAGES</span>
          </div>
          <div className='font-montserrat fs-30 sb-blue-700'>OR</div>
          <div
            className='footer-box build-package-options font-montserrat fs-28 sb-blue-700 cp'
            onClick={() => {
              history.push(`/booking/package/reservation/${fisheryId}`);
            }}
          >
            <img src={pencilIcon} width={150} height={150} alt='Build Icon' />
            <span>BUILD YOUR OWN PACKAGE</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PackageOption;
